import get from 'lodash/get';

/**
 * Normalizes a `tools_history` payload into the shape the UI renders.
 *
 * @param {Object} response - Raw backend payload (`{ tools: [...] }`).
 * @returns {Array<{tool: string, commandId: number, createDate: string}>} One entry per command.
 */
const parseToolsHistory = (response) => get(response, 'tools', []).map((item) => ({
  tool: item.command,
  commandId: item.command_id,
  createDate: item.create_date
}));

export default parseToolsHistory;
